module.exports = __webpack_public_path__ + "static/media/cihr-logo.3fc2f251.svg";